import cls from './GetQuoteSection.module.css';
import { Button } from '@/components/UI/Button/Button';
import { GetQuoteImage } from '@/utils/images/GetQuote';
import { CALENDAR_URL } from '@/utils/consts';

export const GetQuoteSection = () => {
    return (
        <section className={cls.getQuoteSection}>
            <div className={cls.sectionWrapper}>
                <div className={cls.formContainer}>
                    <div className={cls.sectionHeader}>
                        <h2 className={cls.title}>Contact us</h2>
                        <p className={cls.subtitle}>Tell us about your project or book a time that works for you.</p>
                    </div>
                    <GetQuoteImage className={cls.getQuoteImage} />
                    <div className={cls.actions}>
                        <Button href="mailto:dmytro@udata.company" className={cls.actionButton} invert>
                            Email us
                        </Button>
                        <Button href={CALENDAR_URL} className={cls.actionButton}>
                            Schedule a Call
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};
